import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ISSUES_RESULTS = `${TASK_SERVICE}/issue-results`;

export const issuesResults = {
  /**
   * Upsert a issue result for a existing issue or a new issue.
   *
   * @param {Object} data - The data of the issue result to create or update.
   * @param {string} data.id- The ID of a existing issue results on a new guid.
   * @param {string} data.issueId - The ID of the issue or a guid for the new issue result.
   * @param {string} data.attemptId - The ID of the attempt.
   * @param {string} data.type - The type of the issue.
   * @param {string} data.description - The description of the issue.
   * @param {string} data.repairDescription - The repair description.
   * @param {string} data.originalDescription - The original issue description.
   * @param {string} data.diagnosedIssue - The diagnosed issue value.
   * @param {string} data.reviewDescription - The review description.
   * @param {string} data.status - The status of the issue.
   *
   * @returns {Promise<Object>} The response from the API request.
   */
  upsertIssueResult: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_ISSUES_RESULTS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  getUpsertOptions: async ({ data }) =>
    apiOptions({
      url: API_ISSUES_RESULTS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    }),
};
